import img1 from '/static/img/bookNow/service/img1.png'
import img2 from '/static/img/bookNow/service/img2.png'
import img3 from '/static/img/bookNow/service/img3.png'
const serviceInfo = {
    img1:img1,
    img2:img2,
    img3:img3,
    title:'First-Class Service',
    descList:[
        {
            id:1,
            desc:'We specialize in every detail of any trip'
        },
        {
            id:2,
            desc:'We will organize everything for you, from the process to the catering and accommodation'
        },
        {
            id:3,
            desc:'We send our experienced leaders to make sure the program is perfect!'
        },
        {
            id:4,
            desc:'Our travel team specializes in planning professional lines of good grief so you can enjoy every moment!'
        },
    ]
}

export default{
    serviceInfo
}